const guidePost = (WpTag = '') => `
  databaseId
  title
  content
  date
  featuredImage {
    node {
      altText
      sourceUrl
      srcSet
    }
  }
  categories {
    nodes {
      slug
      name
    }
  }
  id
  slug
  tags {
    nodes {
      slug
      name
    }
  }
  uri
  guide {
    guideInActionForm
    guideHero {
      guideHeroTitle
      guideHeroDescription
      guideHeroBanner {
        altText
        sourceUrl
      }
      guideHeroBackButton
    }
    guideCustomTitleForArticle
    guideAttachFileToDownload {
      mediaItemUrl
    }
  }
  seo {
    canonical
    cornerstone
    focuskw
    metaDesc
    metaKeywords
    metaRobotsNofollow
    metaRobotsNoindex
    opengraphAuthor
    opengraphDescription
    opengraphModifiedTime
    opengraphPublishedTime
    opengraphPublisher
    opengraphSiteName
    opengraphTitle
    opengraphType
    opengraphUrl
    readingTime
    title
    twitterDescription
    twitterTitle
    opengraphImage {
      sourceUrl
    }
    twitterImage {
      sourceUrl
    }
    breadcrumbs {
      text
      url
    }
    schema {
      articleType
      pageType
    }
  }
  language {
    code
    name
    locale
    slug
  }
`;

module.exports.guidePost = guidePost;
